import React, { ReactElement } from "react";
import { Route, Routes } from "react-router-dom";
import { KeyboardShortcutProvider } from "../../contexts/KeyboardShortcutContext";
import useRouting from "../../contexts/Routing";
import Agent from "./Agent";
import { SelectionStateProvider } from "./selection-state";

export default function AgentRoute() : ReactElement {
    const { Paths } = useRouting();

    return (
        <KeyboardShortcutProvider>
            <SelectionStateProvider>
                <Routes>
                    <Route path="/" element={<Agent />} />
                    <Route index element={<Agent />} />
                    <Route path={Paths.AGENT_CHAT.replace(`${Paths.AGENT}/`, "")} element={<Agent />} />
                </Routes>
            </SelectionStateProvider>
        </KeyboardShortcutProvider>
    );
}

AgentRoute.defaultProps = {
    component: undefined,
    children: undefined,
    exact: true,
};
